import React from 'react';
import { ListGroup, ListGroupItem, Card } from 'reactstrap';
import { useFetch, PseudoStates } from '@cordata/buffet';
import { useTranslation } from 'react-i18next';
import { capitalize } from 'lodash';

import ListGroupItemPatients from '~/components/Patient/ListGroupItem';

const PatientsIndex = () => {
  const [status, data] = useFetch('summary-patients', {
    params: {
      currentDivisionOnly: true,
    },
  });
  const [t] = useTranslation();

  return (
    <Card>
      {status === 'success' ? (
        <ListGroup flush>
          {data.length ? data.map(d => (
            <ListGroupItemPatients
              key={d.attributes.patientUid}
              data={d}
            />
          )) : (
            <ListGroupItem>
              No {capitalize(t('patients'))}
            </ListGroupItem>
          )}
        </ListGroup>
      ) : (
        <PseudoStates isLoading={status === 'loading'} error={status === 'error'} />
      )}
    </Card>
  );
};

export default PatientsIndex;
